import { useNavigate } from 'react-router-dom';
import { Button } from '@newcore/ui/buttons';
import { FontWeights } from '@newcore/ui/enums/font-weights';
import { Sizes } from '@newcore/ui/enums/sizes';
import { TextSizes } from '@newcore/ui/enums/typography-text-sizes';
import { ButtonVariants } from '@newcore/ui/enums/variants';
import { Text } from '@newcore/ui/typography';
import errorImage from '@/assets/error-image.svg';
import { LogoVertical } from '@/components/logos';
import { Page } from '@/components/ui/page';
import { makeFullPath } from '@/utils/path-utils';

export default function NotFoundPage() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate(makeFullPath('/login'));
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Page className='flex flex-col justify-center items-center'>
      <div className='flex flex-col items-center gap-1 text-center relative'>
        <LogoVertical className='absolute -top-36 left-1/2 -translate-x-1/2 ' />

        <img src={errorImage} alt='Not Found' className='mb-4' />

        <Text as='h1' size={TextSizes.MD} weight={FontWeights.BOLD}>
          404
        </Text>

        <Text
          as='p'
          size={TextSizes.MD}
          className='flex flex-col gap-1 text-secondary'
        >
          Page not found.
        </Text>
      </div>

      <div className='flex flex-col sm:flex-row gap-3 w-full sm:w-auto mt-10'>
        <Button
          variant={ButtonVariants.SECONDARY}
          size={Sizes.MD}
          onClick={handleGoBack}
          className='min-w-[140px]'
        >
          Go Back
        </Button>
        <Button
          variant={ButtonVariants.PRIMARY}
          size={Sizes.MD}
          onClick={handleGoHome}
          className='min-w-[140px]'
        >
          Back to Login
        </Button>
      </div>
    </Page>
  );
}
